export default {
  // 查询我的操作日志列表
  getMyOperationLogs: {
    url: '/systemApi/getMyOperationLogs',
    method: 'POST'
  },
  // 查询我的操作日志列表
  getAllOperationLogs: {
    url: '/systemApi/getAllOperationLogs',
    method: 'POST'
  },
  // 查询操作日志详情
  getOperationLogDetail: {
    url: '/systemApi/getOperationLogDetail',
    method: 'GET'
  },
  // 设置内网地址
  setInnerNet: {
    url: '/systemApi/setInnerNet',
    method: 'POST'
  },
  // 获取内网地址
  getInnerNet: {
    url: '/systemApi/getInnerNet',
    method: 'GET'
  }
}